"use client";

import { Button } from "@/components/ui/button";
export default function AboutHero() {
  return <section id="about-hero" className="text-[#FDFCF9] py-20 relative overflow-hidden !bg-[rgba(241,241,243,1)] md:py-28 lg:py-32">
      {}
      <div className="absolute top-0 right-0 -mt-24 -mr-24 w-96 h-96 bg-accent/30 rounded-lg blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 -mb-24 -ml-24 w-80 h-80 bg-primary/10 rounded-lg blur-3xl pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
          {}
          
          <h1 className="font-default font-bold tracking-tighter mb-8 leading-[1.1] text-4xl sm:text-5xl lg:text-7xl px-4 sm:px-6 lg:px-8 rounded-lg !bg-[rgba(239,236,226,1)] text-chart-5">Evidence‑based. Commercially grounded.&nbsp;</h1>

          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-sans font-bold text-[#efc318] max-w-3xl leading-tight mb-6">
            Feel Good Works is a UK workplace wellbeing consultancy that helps organisations find the root causes of workplace stress and fix them.
          </p>
          
          <p className="text-base sm:text-lg md:text-xl font-sans font-bold max-w-2xl leading-relaxed mb-12 text-primary-foreground">
            Most wellbeing consultancies focus on the symptoms of stress. We focus on the causes. We help you identify the specific organisational factors that are driving stress in your business, and then we help you fix them.
          </p>
          
        </div>
      </div>
    </section>;
}